import request from '@/utils/request'

/**
 * 删除商家
 * @param {Object} data 包含storeId和storeTypeCd
 * @returns {Promise}
 */
export function deleteStore(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/store.deleteStore',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}